import React, {Component} from 'react'
import server from '../../server'
import PatientDetail from './PatientDetail';
import PatientCard from './PatientCard';

class ClinicSummary extends Component{
    render(){
        return(
            <div class="col2-app__side-nav peers bdR bgc-white">
                <div class="w-100p">
                    <div class="peers w-100p ai-c jc-sb content-header">
                        <div class="p-10">
                            <h5 class="m-0 c-client-secondary">Clínica</h5>
                            <h4 class="m-0">{this.props.name}</h4>
                        </div>
                        <button type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0  bdrs-2 cur-p c-client-secondary">
                            <i class="material-icons">close</i>
                        </button>
                    </div>
                    <div class="peers w-100p ai-c jc-sb content-header">
                        <div class="p-10 w-100p searchCPF">
                            <input onChange={this.props.changeFilter} value={this.props.filter} class="form-control" name="inputCPF" placeholder="Buscar CPF" type="text"/>
                            <button class="btn btn-default mL-10 h-100p" type="button">Buscar</button>
                        </div>
                    </div>
                    <div class="w-100p">
                        <h3 class="ta-c">Indicadores</h3>
                        <hr class="small bdc-client-default"/>
                    </div>

                    <div class="p-10 peers ai-c jc-sb  w-100p">
                        <div class="w-50p p-10 mB-20 bdR ai-c ta-c">
                            <i class="fa fa-user fsz-xl c-client-default"></i>
                            <h3 class="m-0">{this.props.total_vinc}</h3>
                            <div class="fsz-xs c-client-secondary">Pacientes Vinculados</div>

                        </div>
                        <div class="w-50p p-10 mB-20 ai-c ta-c">
                            <i class="fa fa-stethoscope fsz-xl c-client-default"></i>
                            <h3 class="m-0">{this.props.total_appointments}</h3>
                            <div class="fsz-xs c-client-secondary">Pacientes atendidos</div>
                        </div>
                        {JSON.parse(localStorage.getItem("user")).type == "fisioterapists"?
                        <div style={{display:"flex"}}>
                            <div class="w-50p p-10 mB-20 bdR ai-c ta-c">
                                <i class="fa fa-user-md fsz-xl c-client-default"></i>
                                <h3 class="m-0">{this.props.app_attended}</h3>
                                <div class="fsz-xs c-client-secondary">Atendimentos realizados</div>
                            </div>
                            <div class="w-50p p-10 mB-20 ai-c ta-c">
                                <i class="fa fa-calendar-check-o fsz-xl c-client-default"></i>

                                <h3 class="m-0">{this.props.total_month}</h3>
                                <div class="fsz-xs c-client-secondary">Atendimentos este mês</div>
                            </div>
                        </div>:<div></div>}
                    </div>
                </div>
            </div>
        )
    }
}

class Patients extends Component{
    state = {
        patients: [],
        numberPatients: "Carregando...",
        patientDetails: [],
        attended:0,
        patient: 0,
        apointments: 0,
        modal:false,
        right:1,
        filter:""
    }

    componentWillMount(){
      this.refresh()
    }

    createCards = (data) =>{
        let patients = [];
        let patientDetails = []
        let appointments = 0;
        let month_appointments = 0;
        let total_appointments = 0;
        let attended = 0;
        let app_attended = 0;

        for(let patient in data){
            let patientData = data[patient]
            if(patientData.appointments.length > 0)
                total_appointments += 1;
            patientDetails.push(data[patient])
            patients.push(<PatientCard key={patientData.name + "/?/" + patientData.cpf} 
                                       onClick={() => this.setState({right:0,patient:patient}, () => console.log(this.state.patient))}
                                       count={patient} 
                                       id={patient} 
                                       data={patientData} 
                                       attended={() => this.setState({"attended":this.state.attended + 1})}/>)
        }
        this.setState({"patients":patients,
                        "appointments":appointments,
                        "patientDetails":patientDetails,
                        total_vinc: data.length,
                        total_appointments, total_appointments,
                        total_month: month_appointments,
                        attended:attended,
                        app_attended:app_attended,
                        numberPatients:patients.length})
    }

    fisioterapistGetPatients = () =>{
        this.setState({name: server.user.name});

        server.get("fisioterapists/" + server.user.id + "/patients", (data) =>{
            this.createCards(data);
        });
    }

    clinicGetPatients = () =>{
        let clinic = JSON.parse(localStorage.getItem("clinic"));
        this.setState({name: clinic.name});

        server.get("clinics/" + clinic.id + "/patients",(data) => {
            this.createCards(data);
        })
    }

    refresh = () =>{    
        if(server.userType == "fisioterapist")this.fisioterapistGetPatients();
        else this.clinicGetPatients();
    }

    componentDidMount(){
        let obj = this;
    }

    attend = () => {
        server.charge_appointment(this.state.appointment_id,() => this.props.alert("Consulta cobrada com sucesso"), (error)=>this.props.alert("Erro ao cobrar consulta. Tente novamente.") );
        this.setState({modal:false},this.refresh);
    }

    saveAlterations = () =>{
        this.setState({right:1,patients:[]});
        this.refresh();
    }

    filter = () =>{
        const filter = this.state.filter.toLowerCase();
        let filtered = [];
        this.state.patients.forEach(appointment =>{
            const split = appointment.key.split("/?/");
            const name = split[0].toLowerCase();
            const cpf = split[1].toLowerCase();

            if(name.indexOf(filter) != -1 || cpf.indexOf(filter) != -1) filtered.push(appointment);
        })
        
        return filtered;
    }


    render(){
        let filtered = this.filter();
        return(
        <div class="col2-app">
            <ClinicSummary name={this.state.name} 
                           changeFilter={(e)=> this.setState({filter:e.target.value})} 
                           filter={this.state.filter} 
                           appointments={this.state.appointments} 
                           total_vinc={this.state.total_vinc}
                           total_appointments={this.state.total_appointments}
                           attended={this.state.attended} 
                           app_attended={this.state.app_attended}/>
            <div class="col2-app__wrapper">
                <div class="col2-list h-100p">
                    <div class="peers w-100p ai-c jc-sb content-header">
                        <div class="content-header__left">
                            <button type="button" class="page-side-toggle d-n@md+ btn btn-clear pX-5 pY-0  bdrs-2 cur-p c-client-secondary">
                                <i style={{fontSize:20}} class="fa fa-caret-right"></i>
                            </button>
                            <div class="content-header__title">
                                <h3 class="m-0">
                                    Pacientes <span class="c-client-default fsz-sm"> ({this.state.numberPatients})</span>
                                </h3>
                            </div>

                        </div>
                    </div>
                    <div class="scrollable h-100p">
                        <div class="content-data peers  ai-c jc-c">
                            {filtered}   
                        </div>
                        <PatientDetail refresh={this.refresh} alert={this.props.alert} open={this.state.right} onClose={this.saveAlterations} modal={(id,appointment_pos,appointment_id) => this.setState({modal:true,id:id,appointment_pos:appointment_pos,appointment_id:appointment_id})} data={this.state.patientDetails[this.state.patient]} />
                    </div>
                </div>
            </div>
            <div class="bcg-overlay open-details"></div>
        </div>
        )
    }
}

export default Patients



// WEBPACK FOOTER //
// ./src/pages/patients/Patients.js